import React from 'react';

// Catches render-time errors (and failed lazy-chunk loads) so one broken page
// shows a recovery screen instead of a blank app.
class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled UI error:', error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="d-flex flex-column justify-content-center align-items-center text-center p-4" style={{ minHeight: '100vh' }}>
        <h4 className="mb-2">Something went wrong</h4>
        <p className="text-muted mb-3">
          The page hit an unexpected error. You can try again, or reload the application.
        </p>
        <div className="d-flex gap-2">
          <button type="button" className="btn btn-outline-secondary" onClick={() => this.setState({ hasError: false })}>
            Try again
          </button>
          <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
            Reload
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
